export const insuredNoTypeList = [
    {
        value: '居民身份证',
        label: '居民身份证',
    },{
        value: '税务登记证',
        label: '税务登记证',
    },{
        value: '统一社会信用代码',
        label: '统一社会信用代码',
    },{
        value: '组织机构代码',
        label: '组织机构代码',
    },{
        value: '工商注册号码',
        label: '工商注册号码',
    },{
        value: '非自然人-其他',
        label: '非自然人-其他',
    },{
        value: '护照',
        label: '护照',
    },{
        value: '军人证',
        label: '军人证',
    },{
        value: '自然人-其他',
        label: '自然人-其他',
    },{
        value: '外国人永久居留证',
        label: '外国人永久居留证',
    }
]
export const relationList = [
    {
        value: '子女',
        label: '子女',
    },{
        value: '父母',
        label: '父母',
    },{
        value: '配偶',
        label: '配偶',
    },{
        value: '本人',
        label: '本人',
    },{
        value: '抚养',
        label: '抚养',
    },{
        value: '扶养',
        label: '扶养',
    },{
        value: '其它',
        label: '其它',
    },{
        value: '赡养',
        label: '赡养',
    },{
        value: '雇主',
        label: '雇主',
    },{
        value: '雇员',
        label: '雇员',
    },{
        value: '监护人',
        label: '监护人',
    },{
        value: '被监护人',
        label: '被监护人',
    },{
        value: '朋友',
        label: '朋友',
    },{
        value: '未知',
        label: '未知',
    }
]

export const cCourPlaceList = [
    {
        value: '1',
        label: '医院',
    },{
        value: '2',
        label: '事故地',
    },{
        value: '3',
        label: '常住地',
    },{
        value: '4',
        label: '住宅',
    },{
        value: '5',
        label: '就诊地',
    },{
        value: '6',
        label: '事故处理政府职能部门',
    }
]

export const cCourProList = [
    {
        value: '1',
        label: '正面调查',
    },{
        value: '2',
        label: '基础调查',
    },{
        value: '3',
        label: '医疗查勘',
    },{
        value: '4',
        label: '事故查勘',
    }
]

export const cCourRelaList = [
    {
        value: '601002',
        label: '子女',
    },{
        value: '601003',
        label: '父母',
    },{
        value: '601004',
        label: '配偶',
    },{
        value: '601005',
        label: '本人',
    },{
        value: '601006',
        label: '抚养',
    },{
        value: '601007',
        label: '扶养',
    },{
        value: '601008',
        label: '其它',
    },{
        value: '601009',
        label: '赡养',
    },{
        value: '601011',
        label: '雇主',
    },{
        value: '601012',
        label: '雇员',
    },{
        value: '601013',
        label: '监护人',
    },{
        value: '601014',
        label: '被监护人',
    },{
        value: '601015',
        label: '朋友',
    },{
        value: '601016',
        label: '未知',
    }
]
export const DcTaskActionList = [
    {
        value: 0,
        label: '新案件',
    },{
        value: 10,
        label: '案件待派机构',
    },{
        value: 20,
        label: '案件作业中',
    },{
        value: 21,
        label: '展业案件审核',
    },{
        value: 25,
        label: '案件待总部审核',
    },{
        value: 26,
        label: '待回复委托主体',
    },{
        value: 30,
        label: '案件已回复委托主体',
    },{
        value: 40,
        label: '案件完成',
    },{
        value: 60,
        label: '案件委托主体退回',
    },{
        value: 50,
        label: '案件结案',
    },{
        value: 70,
        label: '取消委托',
    }

]

export const DcTaskActionLists = [
    {
        value: -2,
        label: '全部',
    },{
        value: 0,
        label: '新案件',
    },{
        value: 10,
        label: '案件待派机构',
    },{
        value: 20,
        label: '案件作业中',
    },{
        value: 21,
        label: '展业案件审核',
    },{
        value: 25,
        label: '案件待总部审核',
    },{
        value: 26,
        label: '待回复委托主体',
    },{
        value: 30,
        label: '案件已回复委托主体',
    },{
        value: 40,
        label: '案件完成',
    },{
        value: 60,
        label: '案件委托主体退回',
    },{
        value: 50,
        label: '案件结案',
    },{
        value: 70,
        label: '取消委托',
    }

]
export const auditStatusList = [
    {
        value: null,
        label: '全部',
    },
    {
        value: 10,
        label: '待机构审核',
    },
    {
        value: 20,
        label: '机构审核不通过',
    },{
        value: 30,
        label: '机构审核通过',
    },{
        value: 40,
        label: '待总部审核',
    },{
        value: 50,
        label: '总部审核不通过',
    },{
        value: 60,
        label: '总部审核通过',
    }
]

export const ExecuteActionList = [
    {
        value: 0,
        label: '新任务',
    },{
        value: 10,
        label: '任务待派调查员',
    },{
        value: 20,
        label: '任务作业中',
    },{
        value: 25,
        label: '任务待机构审核',
    },{
        value: 30,
        label: '任务待总部审核',
    },{
        value: 40,
        label: '任务退回',
    },{
        value: 50,
        label: '任务完成',
    },{
        value: 70,
        label: '取消委托',
    }
]

export const ExecuteActionLists = [
    {
        value: -2,
        label: '全部',
    },{
        value: 0,
        label: '新任务',
    },{
        value: 10,
        label: '任务待派调查员',
    },{
        value: 20,
        label: '任务作业中',
    },{
        value: 25,
        label: '任务待机构审核',
    },{
        value: 30,
        label: '任务待总部审核',
    },{
        value: 40,
        label: '任务退回',
    },{
        value: 50,
        label: '任务完成',
    },{
        value: 70,
        label: '取消委托',
    }
]

export const InsuredNoTypeList = [
    {
        id: '120001',
        name: '居民身份证',
    },
    {
        id: '100111',
        name: '税务登记证',
    },
    {
        id: '100112',
        name: '统一社会信用代码',
    },
    {
        id: '110001',
        name: '组织机构代码',
    },
    {
        id: '110002',
        name: '工商注册号码',
    },
    {
        id: '110009',
        name: '非自然人-其他',
    },
    {
        id: '120002',
        name: '护照',
    },
    {
        id: '120003',
        name: '军人证',
    },
    {
        id: '120009',
        name: '自然人-其他',
    },
    {
        id: '120012',
        name: '外国人永久居留证',
    },
]


export const CCourModeList = [
    {
        value: '1',
        label: '全案',
    },{
        value: '2',
        label: '单点',
    }
]
export const RefuseRsnList = [
    {
        value: '保险合同成立后，投保人未按照合同约定缴纳保险费',
        label: '保险合同成立后，投保人未按照合同约定缴纳保险费',
    },{
        value: '投保人、被保险人或受益人故意制造保险事故',
        label: '投保人、被保险人或受益人故意制造保险事故',
    },{
        value: '投纵履行或因履行如实义务',
        label: '投纵履行或因履行如实义务',
    },{
        value: '被保险人或受益人且其知道或应当知道保险事故发生之日起超出两年索赔时效的',
        label: '被保险人或受益人且其知道或应当知道保险事故发生之日起超出两年索赔时效的',
    },{
        value: '被保险人故意3聪或者抗拒依法采取的刑事强制措施导致其伤残或者死亡',
        label: '被保险人故意3聪或者抗拒依法采取的刑事强制措施导致其伤残或者死亡',
    },{
        value: '破保险人接受整容手术及其他内、外科手术',
        label: '破保险人接受整容手术及其他内、外科手术',
    },{
        value: '破保险人酒后专驶、无有效驾驶证驾驻或驾驶无有效行驶证的机动车期间',
        label: '破保险人酒后专驶、无有效驾驶证驾驻或驾驶无有效行驶证的机动车期间',
    },{
        value: '被保险人的休养、疗养、身体检查、牙科保健或健康护理挈E治疗性行为',
        label: '被保险人的休养、疗养、身体检查、牙科保健或健康护理挈E治疗性行为',
    },{
        value: '被保险人由于疾病导致身故、瘫痪而不能偿还会本息',
        label: '被保险人由于疾病导致身故、瘫痪而不能偿还会本息',
    },{
        value: '艾滋病或噪艾滋病病毒，精神和行为潼碍(以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类(ICD-10 )》为准)',
        label: '艾滋病或噪艾滋病病毒，精神和行为潼碍(以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类(ICD-10 )》为准)',
    },{
        value: '非意外伤害',
        label: '非意外伤害',
    },{
        value: '指定医院或不符合医院释义',
        label: '指定医院或不符合医院释义',
    },{
        value: '由tt注范围内',
        label: '由tt注范围内',
    },{
        value: '等待期内病症',
        label: '等待期内病症',
    },{
        value: '手术等级不符',
        label: '手术等级不符',
    },{
        value: '同一次住院已累计赔付满90天',
        label: '同一次住院已累计赔付满90天',
    },{
        value: '投保强联保险人亲答',
        label: '投保强联保险人亲答',
    },{
        value: '非被保险人本人出险',
        label: '非被保险人本人出险',
    },{
        value: '不在有效保獐期',
        label: '不在有效保獐期',
    },{
        value: '其他',
        label: '其他',
    }
]

export const cSvyNeedList = [
    {
        value: '1',
        label: '首次理赔申请恶性肿瘤定额给付/医疗给付责任（赠险除外）（健康险）',
    },{
        value: '2',
        label: '首次理赔申请重大疾病定额给付/医疗给付责任（健康险）',
    },{
        value: '3',
        label: '门诊就诊单笔案件预估赔付金额≥1万（健康险）',
    },{
        value: '4',
        label: '门诊就诊单笔单张发票预估赔付金额≥5000元（健康险）',
    },{
        value: '5',
        label: '住院医疗单次就诊预估赔付金额≥5万（健康险）',
    },{
        value: '6',
        label: '首次理赔申请，可疑慢性疾病（慢性肝病、肾病、心脑血管疾病、糖尿病）且预估后续长期需要治疗的（健康险）',
    },{
        value: '7',
        label: '预估赔付金额≥1万且在保全追溯期内出险（健康险）',
    },{
        value: '8',
        label: '预估赔付金额≥1万且在首次投保保单生效7日内（健康险）',
    },{
        value: '9',
        label: '预估赔付金额≥1万且在疾病等待期后7日内出险（健康险）',
    },{
        value: '10',
        label: '黑名单客户案件（健康险）',
    },{
        value: '11',
        label: '虽不在以上范围，但明显存在恶意投保、保险欺诈可能或其他有调查必要的案件，必须提起调查（健康险）',
    },{
        value: '12',
        label: '死亡案件（意外险）',
    },{
        value: '13',
        label: '起保前5日内，止保前5日内报案，且预估赔付金额≥1万（意外险）',
    },{
        value: '14',
        label: '报案信息可判断涉及伤残且预估赔付金额≥5万（意外险）',
    },{
        value: '15',
        label: '团体意外事件（意外险）',
    },{
        value: '16',
        label: '无三方侵权，预估赔付金额≥5万（意外险）',
    },{
        value: '17',
        label: '保单年内出险次数≥3次（意外险）',
    },{
        value: '18',
        label: '黑名单客户案件（意外险）',
    },{
        value: '19',
        label: '虽不在以上范围，但明显存在恶意投保、保险欺诈可能或其他有调查必要的案件，必须提起调查（意外险）',
    }
]

export const cSvyModeList = [
    {
        value: '1',
        label: '全案',
    },{
        value: '2',
        label: '单点',
    }
]

export const cSvyPlaceList = [
    {
        value: '1',
        label: '医院',
    },{
        value: '2',
        label: '事故地',
    },{
        value: '3',
        label: '常住地',
    },{
        value: '4',
        label: '住宅',
    },{
        value: '5',
        label: '就诊地',
    },{
        value: '6',
        label: '事故处理政府职能部门',
    }
]
export const cSvyTypeList = [
    {
        value: '1',
        label: '死亡',
    },{
        value: '2',
        label: '伤残',
    },{
        value: '3',
        label: '重大疾病初次治疗',
    },{
        value: '4',
        label: '慢性病治疗',
    },{
        value: '5',
        label: '高额意外医疗',
    },{
        value: '6',
        label: '高额疾病医疗',
    },{
        value: '7',
        label: '其他',
    }
]
export const insuranceList = [
    {
        value: -2,
        label: '全部',
    },
    {
        value: '责任保险',
        label: '责任保险',
    },{
        value: '意外伤害保险',
        label: '意外伤害保险',
    },{
        value: '健康保险',
        label: '健康保险',
    },{
        value: '其他',
        label: '其他',
    }
]

export const financeStateList = [
    {
        value: null,
        label: '全部',
    },{
        value: 0,
        label: '未开票未回款',
    },{
        value: 10,
        label: '已开票未回款',
    },{
        value: 20,
        label: '已开票部分回款',
    },{
        value: 30,
        label: '回款完成',
    },{
        value: 40,
        label: '回款未开票',
    },{
        value: 50,
        label: '红冲',
    },{
        value: 60,
        label: '作废',
    }
]

export const financeStateLists = [
    {
        value: -2,
        label: '全部',
    },{
        value: 0,
        label: '未开票未回款',
    },{
        value: 10,
        label: '已开票未回款',
    },{
        value: 20,
        label: '已开票部分回款',
    },{
        value: 30,
        label: '回款完成',
    },{
        value: 40,
        label: '回款未开票',
    },{
        value: 50,
        label: '红冲',
    },{
        value: 60,
        label: '作废',
    }
]

export const taskFeeReasonList = [
    '重复案件',
    '申诉案件',
    '其他', 
]

export const isBigList = [
    {
        value:true,
        label:'是',
    },{
        value:false,
        label:'否',
    }
]
export const isBigStrList = [
    {
        value:'死亡',
        label:'死亡',
    },{
        value:'伤残',
        label:'伤残',
    },{
        value:'重疾',
        label:'重疾',
    }
]
export const isFiveList = [
    {
        value:true,
        label:'是',
    },{
        value:false,
        label:'否',
    }
]

